export const coursePasswords = ["devikamu"];
